"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  ACTION: 'Action',
  APPROVE: 'Approve',
  APPROVAL: 'Approval',
  APPROVERS: 'Approver(s)',
  CLOSE: 'Close',
  COPY: 'Copy',
  CANCEL: 'Cancel',
  COMMENTS: 'Comments',
  DAYS: 'Days',
  DESCRIPTION: 'Description',
  FOR: 'for',
  NONE: 'None',
  LOADING: 'Loading...',
  OPTIONAL: 'Optional',
  MY_SECRETS: 'My Secrets',
  TYPE: 'Type',
  MY_APPROVALS_AND_REQUEST_MODULE: {
    APPROVALS_LOADING: 'My Approvals Loading',
    APPROVE_REQUEST: 'Approve Request?',
    APPROVAL_STATUS: 'Approval status',
    APPROVED_BY: 'Approved By',
    APPROVED_ON: 'Approved On',
    EXPIRED_ON: 'Expired On',
    FETCHING_APPROVALS: 'Fetching approvals details',
    FETCHING_REQUESTS: 'My Requests Loading',
    PERMISSION_GRANTED: 'permission will be granted to',
    PERMISSION_DENIED: 'permission will be denied to',
    REJECT_REQUEST: 'Reject Request?',
    REQUESTED_ON: 'Requested On',
    REQUESTED_BY: 'Requested By',
    REQUEST_APPROVED: 'The Request is approved',
    REQUEST_REJECTED: 'The Request is rejected',
    REQUEST_TYPE: 'Request type',
    REQUEST_NOT_APPROVED: 'Could not approve the request. {{reason}}.',
    REQUEST_NOT_REJECTED: 'Could not reject the request. {{reason}}.',
    REQUEST_DATE: 'Request Date',
    REQUEST_VALIDITY: 'Request Validity',
    REJECTED_BY: 'Rejected By',
    REJECTED_ON: 'Rejected On',
    SEARCH_RESOURCE: 'Search by Resource',
    SEARCH_NOT_SUPPORTED: 'Search is not supported on this screen',
    SEARCH_REQUEST: 'Search Resource',
    MESSAGE_EXPIRED: 'This request has expired due to no action from approvers',
    MESSAGE_APPROVED: 'This request is approved by {{userName}}',
    MESSAGE_REJECTED: 'This request is rejected by {{userName}}',
    APPROVAL_EXPIRED_MESSAGE: 'Validity expired',
    MANAGE_REQUEST_TITLE: 'Manage Request',
    VIEW_REQUEST_TITLE: 'View Request',
    APPROVE_REQUEST_TOOLTIP: 'Approve Request',
    REJECT_REQUEST_TOOLTIP: 'Reject Request',
    WITHDRAW_REQUEST: 'Withdraw Request',
    WITHDRAW_REQUEST_PROMPT: 'You are about to withdraw the request. Do you want to proceed?',
    YES_WITHDRAW: 'Yes, Withdraw',
    CLOSE: 'Close',
    APPROVERS: 'Approvers',
    STATUS: 'Status',
    JUSTIFICATION: 'Justification',
    PROFILE_CHECKOUT_REQUEST: 'Profile checkout request',
    SECRET_VIEW_REQUEST: 'Secret View request',
    REQUEST_WITHDRAWN: 'Request successfully withdrawn.',
    MANAGE_REQUEST_TOOLTIP: 'Manage Request',
    VIEW_REQUEST_TOOLTIP: 'View Request'
  },
  RESOURCE: 'Resource',
  REJECT: 'Reject',
  SECRETS_MODULE: {
    ALL_SECRETS: 'All Secrets',
    COPIED_TO_CLIPBOARD: 'Copied to clipboard',
    COPY_ALL: 'Copy All',
    DOWNLOAD: 'Download',
    ERROR_LOADING_SECRET: 'Could not load secret. {{reason}}.',
    ERROR_LOADING_SECRETS_LIST: 'Could not load secrets. {{reason}}.',
    HIDE: 'Hide',
    LOADING_NODE_DATA: 'Loading Node...',
    APPROVAL_MESSAGE: '{{userName}} has requested {{accessType}} access for secret {{secretName}}',
    PROFILE_APPROVAL_MESSAGE: '{{userName}} has requested {{accessType}} access for profile {{secretName}}',
    MY_APPROVALS: 'My Approvals',
    MY_REQUESTS: 'My Requests',
    MY_SECRETS: 'My Secrets',
    NO_ACTIONS_AVAILABLE: 'No Actions Available',
    SECRET_LOADING_MESSAGE: 'Loading Secrets...',
    SECRET_DETAILS_LOADING_MESSAGE: "Loading Secret...",
    SECRETS_NAME_HEADER: 'Secret Name',
    SECRETS_PATH_HEADER: 'Path',
    SECRETS_SEARCH_PLACEHOLDER: 'Search by Secret Name',
    SECRETS_STATUS_HEADER: 'Status',
    SHOW: 'Show',
    VIEW_SECRET_TOOLTIP: 'View secret',
    WAITING_FOR_APPROVAL: 'Waiting for Approval',
    WAITING_FOR_APPROVAL_PRIMARY_BUTTON: 'Ok',
    WAITING_FOR_APPROVAL_DIALOG_MESSAGE: 'The request is waiting for approval.',
    NOTIFIED_TEXT: 'You will be notified about the status of this request.',
    TRACK_TEXT: 'You can also track this request under the “My Requests” section.',
    VIEW_ACTION: 'View Secret',
    SEND_REQUEST_BUTTON: 'Send Request',
    NEED_APPROVAL: 'Approval is required to access this profile',
    APPROVAL_REQUEST_SENT: 'This request can be approved by:',
    SENDING_APPROVAL_REQUEST: 'Sending approval request...',
    JUSTIFICATION_TEXT: 'Justification',
    JUSTIFICATION_LENGTH_MAX: 'Justification can not be longer than 255 characters.',
    APPROVAL_REQUIRED_TEXT: 'Approval Required',
    JUSTIFICATION_REQUIRED: 'Justification is required.',
    AVAILABLE_TEXT: 'Available',
    ACCESS_REQUEST_SENT_MESSAGE: 'Access request is sent for approval.',
    LOADING_APPROVERS_DETAILS: 'Loading approvers details...',
    APPROVAL_PENDING_TEXT: 'Approval Pending',
    APPROVAL_DENIED_TEXT: 'Access Denied',
    ALREADY_APPROVED: 'Request is already approved',
    ALREADY_REJECTED: 'Request is already rejected',
    ALREADY_EXPIRED: 'Request Expired',
    VIEW_SECRET: 'View Secret',
    ACCESS_PROFILE: 'Access Profile',
    REJECTED_STATUS: 'Rejected',
    APPROVED_STATUS: 'Approved',
    TIMEOUT_STATUS: 'Request Expired',
    CANCELLED_STATUS: 'Request Withdrawn',
    APPROVE_SECRET_ACTION_MSG: '{{actionName}} permission will be granted to {{userName}} for {{resource}}',
    REJECT_SECRET_ACTION_MSG: '{{actionName}} permission will be denied to {{userName}} for {{resource}}',
    NONE_TEXT: 'None',
    DETAILS_FAILURE_MESSAGE: 'The details could not be fetched. {{reason}}',
    UNABLE_TO_DOWNLOAD_FILE: 'An error occurred while loading the file',
    ACCESS_REQUEST: 'Access Request',
    SECRET: 'Secret'
  },
  VAULT_DETAILS_FETCHING_MESSAGE: 'Fetching secret details...',
  JUSTIFICATION: 'Justification',
  YES: 'Yes',
  NO: 'No',
  YES_DELETE: 'Yes, Delete',
  YES_DISABLE: 'Yes, Disable',
  YES_ENABLE: 'Yes, Enable',
  YES_SAVE: 'Yes, Save',
  YES_DISCARD: 'Yes, Discard Without Saving',
  YES_APPROVE: 'Yes, Approve',
  YES_REJECT: 'Yes, Reject'
};
exports.default = _default;